"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _reactComponents = require("@cimpress/react-components");

var colors = _interopRequireWildcard(require("@cimpress/react-components/lib/colors"));

require("./pivotingController.css");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _EditAttribute = _interopRequireDefault(require("./EditAttribute"));

var PivotingController =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(PivotingController, _Component);

  function PivotingController(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, PivotingController);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(PivotingController).call(this, props));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "init", function (defaultRowOption, options, selectedRow, selectedColumn) {
      if (defaultRowOption && selectedRow === undefined) {
        var match = options && options.find(function (option) {
          return option.label.toLowerCase() === defaultRowOption.toLowerCase();
        });

        if (match) {
          _this.props.onRowSelectionChange(match);
        } else {
          _this.props.onRowSelectionChange(undefined);
        }
      }

      if (!selectedColumn) {
        _this.props.onColumnSelectionChange(undefined);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "openEditRowModal", function () {
      _this.setState({
        selectedAttribute: _this.props.selectedRow,
        openEditAttribute: true
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "openEditColumnModal", function () {
      _this.setState({
        selectedAttribute: _this.props.selectedColumn,
        openEditAttribute: true
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "closeEditAttributeModal", function () {
      _this.setState({
        openEditAttribute: false
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "reset", function (event) {
      event.preventDefault();
      event.stopPropagation();
      var _this$props = _this.props,
          defaultRowOption = _this$props.defaultRowOption,
          options = _this$props.options,
          selectedRow = _this$props.selectedRow,
          selectedColumn = _this$props.selectedColumn;

      if (defaultRowOption.toLowerCase() !== selectedRow.label.toLowerCase() || selectedColumn) {
        _this.init(defaultRowOption, options, undefined, undefined);
      }
    });
    _this.state = {
      openEditAttribute: false
    };
    var _defaultRowOption = props.defaultRowOption,
        _options = props.options,
        _selectedRow = props.selectedRow,
        _selectedColumn = props.selectedColumn;

    _this.init(_defaultRowOption, _options, _selectedRow, _selectedColumn);

    return _this;
  }

  (0, _createClass2["default"])(PivotingController, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
          defaultRowOption = _this$props2.defaultRowOption,
          options = _this$props2.options,
          selectedRow = _this$props2.selectedRow,
          selectedColumn = _this$props2.selectedColumn,
          sku = _this$props2.sku;

      if (sku !== prevProps.sku) {
        this.init(defaultRowOption, options, selectedRow, selectedColumn);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          selectedRow = _this$props3.selectedRow,
          selectedColumn = _this$props3.selectedColumn,
          onRowSelectionChange = _this$props3.onRowSelectionChange,
          onColumnSelectionChange = _this$props3.onColumnSelectionChange,
          expanded = _this$props3.expanded,
          toggleExpanded = _this$props3.toggleExpanded,
          options = _this$props3.options,
          quantityConfigOptions = _this$props3.quantityConfigOptions,
          setSelectedValuesInOptions = _this$props3.setSelectedValuesInOptions,
          saveQuantityConfig = _this$props3.saveQuantityConfig,
          showPivotConfig = _this$props3.showPivotConfig;
      var _this$state = this.state,
          openEditAttribute = _this$state.openEditAttribute,
          selectedAttribute = _this$state.selectedAttribute;
      var rowOptions = selectedColumn ? options.filter(function (option) {
        return option.label !== selectedColumn.label;
      }) : options;
      var columnOptions = selectedRow ? options.filter(function (option) {
        return option.label !== selectedRow.label;
      }) : options;
      return _react["default"].createElement("div", null, _react["default"].createElement("div", null, selectedAttribute ? _react["default"].createElement(_EditAttribute["default"], {
        open: openEditAttribute,
        closeModal: this.closeEditAttributeModal,
        attribute: selectedAttribute,
        setSelectedValuesInOptions: setSelectedValuesInOptions,
        quantityConfigOptions: quantityConfigOptions,
        saveQuantityConfig: saveQuantityConfig
      }) : null), !showPivotConfig ? _react["default"].createElement("div", null, _react["default"].createElement(_reactComponents.Tooltip, {
        direction: "top",
        style: {
          "float": 'right'
        },
        contents: "Edit Quantities"
      }, _react["default"].createElement("button", {
        className: "pivoting-reset-button edit-quantities",
        onClick: this.openEditRowModal
      }, "Edit Quantities"))) : _react["default"].createElement(_reactComponents.Accordion, {
        className: "pivoting-controller",
        title: _react["default"].createElement("div", {
          style: {
            display: 'contents'
          }
        }, ' ', "Pivot Configuration", expanded ? _react["default"].createElement("button", {
          className: "pivoting-reset-button",
          onClick: this.reset
        }, ' ', "Reset") : null),
        customOpen: expanded,
        onHeaderClick: toggleExpanded
      }, _react["default"].createElement("div", {
        className: "edit-attribute-container"
      }, _react["default"].createElement(_reactComponents.Select, {
        label: "First Attribute",
        value: selectedRow,
        options: rowOptions,
        onChange: onRowSelectionChange,
        helpText: "First Attribute to pivot on"
      }), selectedRow ? _react["default"].createElement("div", {
        className: "edit-icon-container"
      }, _react["default"].createElement(_reactComponents.Tooltip, {
        direction: "top",
        contents: "Edit First Attribute"
      }, _react["default"].createElement("button", {
        className: "clickable pricing-table__button edit-quantity-button",
        onClick: this.openEditRowModal
      }, _react["default"].createElement(_reactComponents.Icon, {
        color: colors.teal.base,
        name: "pencil-2-l",
        size: "2x"
      })))) : null), _react["default"].createElement("div", {
        className: "edit-attribute-container"
      }, _react["default"].createElement(_reactComponents.Select, {
        label: "Second Attribute",
        value: selectedColumn,
        options: columnOptions,
        onChange: onColumnSelectionChange,
        helpText: "Second Attribute to pivot on"
      }), selectedColumn ? _react["default"].createElement("div", {
        className: "edit-icon-container"
      }, _react["default"].createElement(_reactComponents.Tooltip, {
        direction: "top",
        contents: "Edit Second Attribute"
      }, _react["default"].createElement("button", {
        className: "clickable pricing-table__button edit-quantity-button",
        onClick: this.openEditColumnModal
      }, _react["default"].createElement(_reactComponents.Icon, {
        color: colors.teal.base,
        name: "pencil-2-l",
        size: "2x"
      })))) : null)));
    }
  }]);
  return PivotingController;
}(_react.Component);

exports["default"] = PivotingController;
(0, _defineProperty2["default"])(PivotingController, "propTypes", {
  sku: _propTypes["default"].string.isRequired,
  authToken: _propTypes["default"].string.isRequired,
  options: _propTypes["default"].arrayOf(_propTypes["default"].object).isRequired,
  defaultRowOption: _propTypes["default"].string,
  selectedRow: _propTypes["default"].shape({
    label: _propTypes["default"].string.isRequired
  }),
  selectedColumn: _propTypes["default"].shape({
    label: _propTypes["default"].string.isRequired
  }),
  onRowSelectionChange: _propTypes["default"].func.isRequired,
  onColumnSelectionChange: _propTypes["default"].func.isRequired,
  expanded: _propTypes["default"].bool.isRequired,
  toggleExpanded: _propTypes["default"].func.isRequired,
  setSelectedValuesInOptions: _propTypes["default"].func.isRequired,
  saveQuantityConfig: _propTypes["default"].func.isRequired,
  quantityConfigOptions: _propTypes["default"].arrayOf(_propTypes["default"].object),
  showPivotConfig: _propTypes["default"].bool.isRequired
});
(0, _defineProperty2["default"])(PivotingController, "defaultProps", {
  defaultRowOption: 'Quantity'
});